import { render, staticRenderFns } from "./AboutUs-fr.vue?vue&type=template&id=0cdd9d42&"
import script from "./AboutUs-fr.vue?vue&type=script&lang=js&"
export * from "./AboutUs-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports